var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',_vm._b({domProps:{"innerHTML":_vm._s(_vm.content)}},'p',_vm.attributes,false))
}
var staticRenderFns = []

export { render, staticRenderFns }